import DOMPurify from 'dompurify';

const DEFAULT_SANITIZER_CONFIG = {
  FORBID_ATTR: ['style', 'class'],
};

const sanitize = (html: string, options = DEFAULT_SANITIZER_CONFIG): string => DOMPurify.sanitize(html, options);

export default sanitize;
